import type { IBookingOnboardingRequest } from '@/_apis_/booking/type';
import type { BookingOnboardingFormValues } from './types';

export const createBookingOnboardingSubmissionPayload = (
    values: BookingOnboardingFormValues
): IBookingOnboardingRequest => ({
    restaurantName: values.restaurantName.trim(),
    email: values.email.trim(),
    contact: values.contact.trim(),
    ownerManagerName: values.ownerManagerName.trim(),
    diningDuration: values.diningDuration.trim(),
    bookingSlotInterval: values.bookingSlotInterval.trim(),
    minimumAdvanceBookingTime: values.minimumAdvanceBookingTime.trim(),
    sessionMaxCapacity: values.sessionMaxCapacity.trim(),
    timezone: values.timezone.trim(),
    bookingType: values.bookingType,
    maxPaxPerBooking: values.maxPaxPerBooking.trim()
});
